export default "<p>list-values-product-configuration works!</p>\r\n"